import React from 'react';

import type CK from '~/types/contentking';

import {
	useCompleteValidateInvitationsSessionMutation,
	useInitiateValidateInvitationsSessionMutation,
} from './useValidationSession.gql';



export default function useValidationSession(accountId: CK.AccountId | null): string | undefined {
	const [initiateSession] = useInitiateValidateInvitationsSessionMutation();
	const [closeSession] = useCompleteValidateInvitationsSessionMutation();
	const [sessionId, setSessionId] = React.useState<string | undefined>(undefined);

	React.useEffect(
		() => {
			if (accountId === null) {
				return;
			}

			let localSessionId: string | undefined;

			initiateSession({
				variables: {
					accountId,
				},
			}).then((response) => {
				localSessionId = response.data?.InitiateValidateInvitationsSession.sessionId ?? undefined;
				setSessionId(localSessionId);
			});

			return () => {
				if (localSessionId !== undefined) {
					closeSession({
						variables: {
							accountId,
							sessionId: localSessionId,
						},
					});
				}
			};
		},
		[
			accountId,
			closeSession,
			initiateSession,
		],
	);

	return sessionId;
}
